export const useAsset = (path: string): string => {
  const assets = import.meta.glob('~/assets/img/**/*', {
    eager: true,
    import: 'default'
  });

  return String(assets[`/assets/${path}`]);
};
